import React, { useCallback, useEffect, useMemo, useState } from "react";
import DataTable, { TableColumn } from "react-data-table-component";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../style/Cancelorder.css";
import { apiAxios } from "../../../../utils/apiAxios";

import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { ManagerOrderReviewRow } from "../../../../Interfaces/ManagerOrderReviewRow";
const API_PATH = process.env.REACT_APP_API_PATH_URL || "";
// Constants
const API_BASE = process.env.REACT_APP_API_BASE_URL;
interface CancelOrderRow {

  orderId: string
  caseId: number
  clinicName: string
  phone: string
  clinicAddress: string
  clinicOrderDate: string
  orderTypeName: string

  millingHub: string
  millingHubMobileNo: string
  millingHubAddress: string

  Amount: string
  totalAmount: string
  paidAmount: string;
  paymentType: string
  status: string

  designerName: string
  designerMobileNo: string

  deliveryPartner: string
  deliveryPartnerMobileNo: string
  deliveryDate: string
  deliveryPartnerAddress: string

  refundAmount: string
  refundDate: string
  refundType: string
  refundReference: string

  cancelledByName: string
  cancelledDate: string

  orderState: string

  cancellationReason: string
  remark: string
  rejectedReason: string
  rejectedDate: string
  refundId: string
}
interface ModalScanFile {
  path: string;
  name: string;
}



const CancelOrderAdmin: React.FC = () => {
  const [activeTab, setActiveTab] = useState("status");
const [showStlModal, setShowStlModal] = useState(false);
const [selectedStl, setSelectedStl] = useState<string | null>(null);
const navigate = useNavigate();
  const [orders, setOrders] = useState<CancelOrderRow[]>([])
  const [searchText, setSearchText] = useState("")
  const [statusFilter, setStatusFilter] = useState("All")
  const [selectedOrder, setSelectedOrder] = useState<CancelOrderRow | null>(null)
  const [showModal, setShowModal] = useState(false)
  const [loading, setLoading] = useState(true)
  const [orderDetails, setOrderDetails] = useState<any>(null);
  const [openDelayIndex, setOpenDelayIndex] = useState<number | null>(null);
  const [detailsLoading, setDetailsLoading] = useState(false);
  const [isOrderModalOpen, setIsOrderModalOpen] = useState(false);
  const [orderReview, setOrderReview] = useState<ManagerOrderReviewRow[]>([]);
  const [scans, setScans] = useState<ModalScanFile[]>([]);
  const [orderView, setOrderView] = useState<"full" | "design">("full");
  const EllipsisText = ({ text }: { text: string }) => (
    <span
      title={text}
      style={{
        display: "inline-block",
        maxWidth: "120px",
        overflow: "hidden",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
      }}
    >
      {text}
    </span>
  );
  /* ================================
     FETCH DATA FROM API
  ================================= */
  useEffect(() => {



    const fetchCancelledOrders = async () => {

      try {


        const response = await apiAxios.get(`${API_BASE}/Central/GetCancelledOrders`);
        const result = await response.data

        if (result.isSuccess) {
          console.log("*********API Response********:", result.dataOne);

          const mapped: CancelOrderRow[] = result.dataOne.map((item: any) => ({

            orderId: item.orderID,
            caseId: item.caseID,
            clinicName: item.clinicName,
            phone: item.clinicMobileNo,

            clinicOrderDate: formatDate(item.orderCreatedDate),
            orderTypeName: item.orderTypeName ?? "-",
            millingHub: item.millingHubName ?? "-",
            millingHubMobileNo: item.millingHubMobileNo ?? "-",

            totalAmount: item.amount?.toString() ?? "0",
            paidAmount: item.paidAmount?.toString() ?? "0",
            paymentType: item.paymentStatus ?? "-",

            // status: item.refundStatus ?? "----",
            status: item.refundStatus ?? "Rejected",

            designerName: item.designerName ?? "-",
            designerMobileNo: item.designerMobileNo ?? "-",

            deliveryPartner: item.deliveryPartner ?? "-",
            deliveryPartnerMobileNo: item.deliveryPartnerMobileNo ?? "-",

            deliveryDate: item.deliveryDate
              ? formatDate(item.deliveryDate)
              : "-",

            refundAmount: item.refundAmount?.toString() ?? "0",

            refundDate: item.refundedOn
              ? formatDate(item.refundedOn)
              : "-",

            refundType: item.refundStatus ?? "-",
            refundReference: item.refundReference ?? "-",
             refundId: item.refundId ?? "-",

            cancelledByName: item.cancelledByName ?? "-",

            cancelledDate: item.cancelledDate
              ? formatDate(item.cancelledDate)
              : "-",

            orderState: item.orderState ?? "-",

            cancellationReason: item.cancellationReason ?? "-",
            remark: item.remarks ?? "-",
            rejectedReason: item.rejectedReason ?? "-",
            rejectedDate: formatDate(item.rejectedDate),

            clinicAddress: item.clinicAddress ?? "-",
            millingHubAddress: item.millingHubAddress ?? "-",
            deliveryPartnerAddress: item.deliveryPartnerAddress ?? "-",

          }))

          setOrders(mapped)

        }

      } catch (error) {

        console.error("Error fetching cancelled orders:", error)

      } finally {

        setLoading(false)

      }

    }

    fetchCancelledOrders()

  }, [])

  const formatDate = (dateString: string | null) => {
    if (!dateString) return "-";

    const date = new Date(dateString);

    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);

    return `${day}/${month}/${year}`;
  };

  /* ================================
     SEARCH + FILTER
  ================================= */
 const filteredOrders = useMemo(() => {

  return orders.filter(o => {

    const matchSearch = [
      o.orderId,
      o.clinicName,
      o.phone,
      o.millingHub,
      o.clinicOrderDate,
      o.designerName,
      o.deliveryPartner,
      o.status
    ]
      .filter(Boolean)
      .some(field =>
        field.toString()
          .toLowerCase()
          .includes(searchText.toLowerCase())
      );

    const matchStatus =
      statusFilter === "All" ||
      o.status === statusFilter;

    // ✅ Same logic as CompleteOrder
    const matchOrderType =
      orderView === "design"
        ? o.orderTypeName === "Design Service"
        : o.orderTypeName !== "Design Service";

    return matchSearch && matchStatus && matchOrderType;

  });

}, [
  orders,
  searchText,
  statusFilter,
  orderView
]);

  /* ================================
 renderDesignFiles
================================= */
  const renderDesignFiles = (review: ManagerOrderReviewRow): React.ReactNode => {
    const designerFileNames = review.designerFileNames || "";
    const designerFilePaths = review.designerFilePaths || "";


    if (!designerFileNames.trim() || !designerFilePaths.trim()) {
      return <span className="text-muted">No design files</span>;
    }

    const fileNames = designerFileNames.split(",").map(name => name.trim()).filter(Boolean);
    const filePaths = designerFilePaths.split(",").map(path => path.trim()).filter(Boolean);

    if (fileNames.length === 0) {
      return <span className="text-muted">No valid file names</span>;
    }

    return (
      <div className="design-files-list">
        {fileNames.map((fileName, index) => {
          const filePath = filePaths[index];
          if (!filePath) return null;

          return (
            <div key={index} className="d-flex align-items-center justify-content-between   px-2 ">
              <div className="d-flex align-items-center">

                <span
                  className="text-truncate"
                  style={{
                    maxWidth: "100px",
                    display: "inline-block",
                    overflow: "hidden",
                    whiteSpace: "nowrap",
                    textOverflow: "ellipsis",
                  }}
                  title={fileName}
                >
                  {fileName}
                </span>
              </div>
              <button
                className="btn btn-sm text-primary"
                onClick={async (e) => {
                  e.preventDefault();
                  e.stopPropagation();
                 await downloadFile(filePath, fileName);
                }}
                title={`Download ${fileName}`}
              >
                <i className="bi bi-download"
                  onClick={async (e) => {
                    e.preventDefault();
                    e.stopPropagation();
                   await downloadFile(filePath, fileName);
                  }}></i>
              </button>
            </div>
          );
        })}
      </div>
    );
  };
  const downloadFile = async (filePath: string, fileName?: string) => {
    const fullUrl = constructFileUrl(filePath);

    try {
      const token = sessionStorage.getItem("token");

      const { data, headers } = await apiAxios.get(fullUrl, {
        responseType: "blob", // ✅ critical
        headers: {
          Authorization: token ? `Bearer ${token}` : "",
          AuthorizationData: token || "",
        },
      });

      // 📄 Get file type
      //const contentType = headers["content-type"];

      // 📄 Try to extract filename from backend
      let finalName = fileName;
      const disposition = headers["content-disposition"];

      if (!finalName && disposition) {
        const match = disposition.match(/filename="?(.+?)"?$/);
        if (match) finalName = match[1];
      }

      finalName = finalName || "download";

      // 📦 Create blob
      //const blob = new Blob([data], { type: contentType });

      const contentType =
        typeof headers["content-type"] === "string"
          ? headers["content-type"]
          : undefined;

      const blob = new Blob([data], {
        type: contentType,
      });
      const url = window.URL.createObjectURL(blob);

      // ⬇️ Trigger download
      const link = document.createElement("a");
      link.href = url;
      link.download = finalName;
      document.body.appendChild(link);
      link.click();

      // 🧹 Cleanup
      setTimeout(() => {
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }, 100);

      toast.success(`Downloading ${finalName}`);
      return true;
    } catch (error: any) {
      console.error("❌ Axios download failed:", error);

      // 🔁 Fallback (keep this)
      try {
        window.open(fullUrl, "_blank");
        toast.info(
          "Opened in new tab. Right-click → Save As to download."
        );
        return false;
      } catch {
        toast.error("Failed to download file");
        return false;
      }
    }
  };
const constructFileUrl = (filePath: string): string => {
  if (!filePath) return "";

  const cleanPath = filePath.trim();

  // Already a complete URL
  if (
    cleanPath.startsWith("http://") ||
    cleanPath.startsWith("https://")
  ) {
    return cleanPath;
  }

  const baseUrl = (
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    ""
  ).replace(/\/api\/?$/, "")
   .replace(/\/$/, "");

  const cleanFilePath = cleanPath.replace(/^\/+/, "");

  return `${baseUrl}/${cleanFilePath}`;
};

  /* ================================
     EXPORT CSV
  ================================= */
  const exportCSV = () => {

    const headers = ["OrderID", "Clinic", "Phone", "Date", "Hub", "Amount", "Payment", "Status"]

    const rows = filteredOrders.map(o => [
      o.orderId,
      o.clinicName,
      o.phone,
      o.clinicOrderDate,
      o.millingHub,
      o.totalAmount,
      o.paymentType,
      o.status
    ])

    const csvContent =
      "data:text/csv;charset=utf-8," +
      [headers, ...rows].map(e => e.join(",")).join("\n")

    const link = document.createElement("a")
    link.href = encodeURI(csvContent)
    link.download = "cancel-orders.csv"
    link.click()

  }

  /* ================================
     STATUS BADGE
  ================================= */
  const getStatusBadge = (status: string) => {

    if (status === "Rejected")
      return <span className="badge bg-danger">{status}</span>

    if (status === "Refunded")
      return <span className="badge bg-success">{status}</span>

    if (status === "Refund Pending")
      return <span className="badge bg-warning text-dark">{status}</span>

    return <span className="badge bg-secondary">{status}</span>

  }

  /* ================================
     TABLE COLUMNS
  ================================= */
  const columns: TableColumn<CancelOrderRow>[] = [

    { name: "Order ID", selector: row => row.orderId, sortable: true },

    {
      name: "Clinic / Phone No.",
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div>
          <div className="fw-semibold">{row.clinicName}</div>
          <div className="text-muted mt-1">{row.phone}</div>
        </div>
      )
    },

    { name: "Order Date", selector: row => row.clinicOrderDate },

    // {
    //   name: "Milling Hub",
    //   sortable: true,
    //   cell: (row) => <EllipsisText text={row.millingHub || "-"} />
    // },
       // Milling Hub - only for non Design Service
    ...(orderView !== "design"
      ? [
          {
            name: "Milling Hub",
            sortable: true,
            cell: (row: CancelOrderRow) => (
              <EllipsisText text={row.millingHub || "-"} />
            )
          }
        ]
      : []),


    {
      name: "Amount",
      cell: row => (
        <span className="amount-pill">
          ₹{row.paidAmount}
        </span>
      )
    },

    {
      name: "Payment",
      sortable: true,
      cell: (row) => (
        <EllipsisText text={row.paymentType || "-"} />
      )
    },
    {
      name: "Status",
      width: "140px",
      cell: row => getStatusBadge(row.status)
    },

    {
      name: "View",

      cell: row => (
        <button
          className="action-btn edit"
          onClick={() => {

            setSelectedOrder(row)
            fetchOrderDetails(row.orderId)
            fetchOrderReviewByCaseId(row.caseId)
            setShowModal(true)

          }}
        >
          <i className="bi bi-eye"></i>
        </button>
      )
      ,

    }

  ]

  const formatToValidDate = (dateTime: string | null, baseDate?: string) => {
    if (!dateTime) return null;

    // If already full ISO datetime
    if (dateTime.includes("T")) {
      return new Date(dateTime);
    }

    // If only time (HH:mm:ss)
    if (baseDate) {
      return new Date(`${baseDate.split("T")[0]}T${dateTime}`);
    }

    return null;
  };

  /* ================================
    Cancel details 
  ================================= */
  const fetchOrderDetails = useCallback(async (orderId: string): Promise<void> => {

    try {
      setDetailsLoading(true);
      setActiveTab("status");

      const res = await apiAxios.get(`${API_BASE}/Central/cancel-order-status`, {
        params: { orderID: orderId }
      });
      if (res.data?.isSuccess && res.data?.data?.length > 0) {
        setOrderDetails(res.data.data[0]);

        const apiData = res.data.data[0];

        const isDesignService = apiData?.isDesignService === true;

        // 🔥 CREATE TIMELINE MANUALLY
        const timeline = [
          {
            time: formatToValidDate(apiData.createdDate),
            event: "Order Created",
            status: "Completed",
          },
          {
            time: formatToValidDate(apiData.paymentTime, apiData.createdDate),

            event: (
              <div>
                <div>
                  <strong>Payment Successful</strong>
                </div>

                <div className="small text-muted mt-1">
                  <div>Original Amount : ₹{apiData?.originalAmount ?? "--"}</div>
                  <div>Discount Amount : ₹{apiData?.discountAmount ?? "--"}</div>
                  <div>Coupon : {apiData?.couponPercentage ?? "--"}% Off</div>
                  <div>
                    <strong>Paid Amount : ₹{apiData?.paidAmount ?? "--"}</strong>
                  </div>
                </div>
              </div>
            ),

            status: apiData.paymentStatus === "Paid" ? "Completed" : "Pending",
          },
          {
            time: formatToValidDate(apiData?.designerActualApprovalTime, apiData?.createdDate),
            event: apiData?.designerApprovalStatus != "Pending" ? `Scan Approved by ${apiData?.design} (Designer)` : "Scan not approved yet",
            status: apiData?.designerApprovalStatus || "Pending",
          },
            ...(!isDesignService
    ? [
        {
          time: formatToValidDate(
            apiData?.millingActualApprovalTime,
            apiData?.createdDate
          ),
          event:
            apiData?.millingApprovalStatus !== "Pending"
              ? `${apiData?.milling} accepted order`
              : "Awaiting milling acceptance",
          status:
            apiData?.millingApprovalStatus || "Pending",
        },
      ]
    : []),
          {
            time: formatToValidDate(apiData?.expectedETA),
            event: "Current Status",
            status: apiData?.currentStatus || "Pending",
          }
        ];

        // 🔥 SET WITH TIMELINE
        setOrderDetails({
          ...apiData,
          timeline
        });
        setIsOrderModalOpen(true);
      }
    } catch {
      toast.error("Failed to load order details");
    } finally {
      setDetailsLoading(false);
    }
  }, []);
  const fetchOrderReviewByCaseId = useCallback(async (caseId: number): Promise<void> => {
    try {

      setDetailsLoading(true);
      const res = await apiAxios.get(`${API_BASE}/Central/cancel-order-review`, {
        params: { caseID: caseId }
      });
      if (res.data?.isSuccess) {
        const reviewData = res.data.data || []; // ✅ ADD THIS

        setOrderReview(reviewData);
        const uniqueScans = new Map<string, { name: string; path: string }>();

        reviewData.forEach((item: any) => {
          const names = (item.fileNames || "")
            .split(",")
            .map((n: string) => n.trim())
            .filter(Boolean);

          const paths = (item.filePaths || "")
            .split(",")
            .map((p: string) => p.trim())
            .filter(Boolean);

          names.forEach((name: string, i: number) => {
            if (paths[i] && !uniqueScans.has(name)) {
              uniqueScans.set(name, {
                name,
                path: paths[i],
              });
            }
          });
        });

        setScans(Array.from(uniqueScans.values()));


      }
    } catch {
      toast.error("Failed to load order review");
    } finally {
      setDetailsLoading(false);
    }
  }, []);
const onViewStl = (scan: ModalScanFile) => {
  if (!scan.path) {
    toast.error("STL not available");
    return;
  }

  navigate("/central/AdminstlpreviewNew", {
    state: {
      stlUrl: `${API_PATH}${scan.path}`,
    },
  });
};
  /* ================================
     DASHBOARD COUNTS
  ================================= */
  const totalOrders = orders.length
  const Rejected = orders.filter(o => o.status === "Rejected").length
  const refunded = orders.filter(o => o.status?.toUpperCase() === "PROCESSED").length;
  const pending = orders.filter(o => o.status?.toUpperCase() === "INITIATED").length;

  return (

    <div className="container-fluid mt-4 ">
      <h4 className="mb-4">Cancel Order</h4>


      <div className="order-status-bar mb-4">

        <div className="status-col">
          <h3>{totalOrders}</h3>
          <span className="status-badge bgnone">Total Orders</span>
        </div>

        <div className="status-col">
          <h3>{Rejected}</h3>
          <div className="status-badge cancelled">
            <i className="bi bi-dash-circle-fill"></i>
            Rejected
          </div>
        </div>

        <div className="status-col">
          <h3>{refunded}</h3>
          <div className="badge-box badge-success">
            <i className="bi bi-cash-stack"></i>
            Refunded
          </div>
        </div>

        <div className="status-col">
          <h3>{pending}</h3>
          <div className="status-badge warning">
            <i className="bi bi-clock-history"></i>
            Refund Pending
          </div>
        </div>

      </div>
        {/* =================================
        ORDER TYPE RADIO BUTTONS
    ================================== */}
    <div className="mb-3 d-flex gap-4">

      <label
        className="d-flex align-items-center"
        style={{ cursor: "pointer" }}
      >
        <input
          type="radio"
          name="orderView"
          checked={orderView === "full"}
          onChange={() => setOrderView("full")}
        />
        <span className="ms-2">Full Service</span>
      </label>

      <label
        className="d-flex align-items-center"
        style={{ cursor: "pointer" }}
      >
        <input
          type="radio"
          name="orderView"
          checked={orderView === "design"}
          onChange={() => setOrderView("design")}
        />
        <span className="ms-2">Design Service</span>
      </label>

    </div>
      

      {/* Controls */}

      <div className="row mb-3">
        <div className="col-md-6 col-12 col-lg-3">
          <div className="input-group">
            <input
              type="text"
              className="form-control cancel-order-searchbtn"
              placeholder="Search order..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />

            <button className="btn btn-primary" type="button">
              <i className="bi bi-search"></i>
            </button>
          </div>
        </div>
        <div className="col-md-6 col-12 col-lg-9 ">
          <div className="d-flex gap-2 justify-content-center justify-content-lg-end margin-topm10px">

            <select
              className="form-select cancel-filter-select"
              onChange={(e) => setStatusFilter(e.target.value)}
            >

              <option>All</option>
              <option>Rejected</option>
              <option>Refunded</option>
              <option>Refund Pending</option>

            </select>

          </div>
        </div>
      </div>

      {/* Table */}

      <div className="premium-card mt-4">
        

        <DataTable
          columns={columns}
          data={filteredOrders}
          pagination
          highlightOnHover
          striped
          responsive
          progressPending={loading}
          fixedHeader
          fixedHeaderScrollHeight="500px"

        />

      </div>

      {/* Modal */}

      {showModal && selectedOrder && (

        <div className="modal fade show d-block modal-bg">
          <div
            className="modal-dialog modal-lg admin-order-modal-dialog"
            style={{ maxWidth: "980px" }}
          >
            <div
              className="modal-content"
              style={{ minHeight: "580px" }}
            >

              <div className="modal-header ">
                {/* <h5>Order Details</h5> */}
                <h5 className="modal-title"> Order Details: {selectedOrder?.orderId || "--"}</h5>
                <button
                  className="custom-close-btn btn-close "
                  onClick={() => setShowModal(false)}
                >
                  <i className="bi bi-x customcross"></i>
                </button>
              </div>
              <div className="dentist-approval-pending pt-3 d-flex justify-content-end align-items-center">
                {getStatusBadge(selectedOrder?.status || "")}
              </div>


              {/* 🔹 TABS */}
              <div className="d-flex border-bottom tab-border-bottom-section-cancel-order tab-border-bottom-section mx-3 pt-2">
                <button
                  className={activeTab === "status" ? "btn order-status-text btn-link active-tab-section" : " btn"}
                  onClick={() => setActiveTab("status")}
                >
                  Order Status
                </button>

                <button
                  className={activeTab === "details" ? "btn order-status-text btn-link active-tab-section" : "btn order-details-btn-sect"}
                  onClick={() => setActiveTab("details")}
                >
                  Order Details
                </button>


              </div>
              <div className="modal-body premium-modal-body">


                {/* ================= STATUS TAB ================= */}
                {activeTab === "status" && (
                  <div className="row">

                    {/* LEFT */}
                    <div className="col-md-6 border-end">

                      <ul className="list-unstyled order-status-list delivery-type-section">
                        {/* <li className="time-event-section-delivery-type">
                          <strong className="strongtext-fontweight Delivery-Type-text">Delivery Type</strong>
                          <span>{orderDetails?.deliveryType || "--"}</span>
                        </li> */}
                         <li className="time-event-section-delivery-type">
  <strong className="strongtext-fontweight Delivery-Type-text">
    Delivery Type
  </strong>

  <span>
    {orderDetails?.isDesignService === true
      ? "Design Service"
      : orderDetails?.deliveryType || "--"}
  </span>
</li>
                        <li className="time-event-section-delivery-type mt-1">
                          <strong className="strongtext-fontweight Delivery-Type-text">Payment Status</strong>
                          <span>{orderDetails?.paymentStatus || "--"}</span>
                        </li>

                        <li className="time-event-section-delivery-type mt-1">
                          <strong className="strongtext-fontweight Delivery-Type-text">Original ETA</strong>
                          <span>
                            {orderDetails?.originalETA
                              ? new Date(orderDetails.originalETA).toLocaleString("en-IN", {
                                day: "2-digit",
                                month: "short",
                                year: "numeric",
                                hour: "2-digit",
                                minute: "2-digit",
                              })
                              : "--"}
                          </span>
                        </li>
                        <li className="time-event-section-delivery-type mt-1">
                          <strong className="strongtext-fontweight Delivery-Type-text">Expected ETA</strong>
                          <span>{orderDetails?.expectedETA
                            ? new Date(orderDetails.expectedETA).toLocaleString("en-IN", {
                              day: "2-digit",
                              month: "short",
                              year: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })
                            : "--"}</span>
                        </li>
                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Delivery Date</strong><span>{selectedOrder.deliveryDate}</span></li>
                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Refund Type</strong><span>{selectedOrder.refundType}</span></li>

                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Refund Amount</strong><span> <h6 className="text-success">  ₹{selectedOrder.refundAmount} </h6></span></li>
                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Refund Reference</strong><span>{selectedOrder.refundId}</span></li>
                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Refund Date</strong><span>{selectedOrder.refundDate} </span></li>

                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Cancelled By</strong><span> {selectedOrder.cancelledByName}</span></li>
                        <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Cancelled Date</strong><span> {selectedOrder.cancelledDate}</span></li>
                        {/* <li className="time-event-section-delivery-type mt-1"><strong className="strongtext-fontweight Delivery-Type-text">Order Status</strong><span className="order-status-text-col">{selectedOrder.orderState}</span></li> */}



                      </ul>
                      <div className="remark-box">
                        <h6>Cancellation Details</h6>

                        {selectedOrder.cancellationReason && (
                          <div className="detail-item">
                            <strong>Cancellation Reason:</strong>
                            <p>{selectedOrder.cancellationReason}</p>
                            <small>{selectedOrder.cancelledDate}</small>
                          </div>
                        )}

                        {selectedOrder.remark &&
                          selectedOrder.remark.trim() !== "" &&
                          selectedOrder.remark.trim() !== "-" && (
                            <div className="detail-item">
                              <strong>Remark By Dentist:</strong>
                              <p>{selectedOrder.remark}</p>
                              <small>{selectedOrder.cancelledDate}</small>
                            </div>
                          )}

                        {selectedOrder.rejectedReason &&
                          selectedOrder.rejectedReason.trim() !== "" &&
                          selectedOrder.rejectedReason.trim() !== "-" && (
                            <div className="detail-item">
                              <strong>Rejection Reason By Admin:</strong>
                              <p>{selectedOrder.rejectedReason}</p>
                              <small>{selectedOrder.rejectedDate}</small>
                            </div>
                          )}
                      </div>


                    </div>

                    {/* RIGHT */}
                    <div className="col-md-6">
                      <ul className="list-unstyled order-status-timeline">

                        <li className="time-event-sectionborder-bottom time-event-section pb-2 mb-2">
                          <strong>Time</strong>
                          <strong>Event</strong>
                          <strong>Status</strong>
                        </li>

                        {(orderDetails?.timeline || []).map((item: any, index: number) => (
                          <li key={index} className="time-event-section">

                            <strong className="strongtext-fontweight Delivery-Type-text">
                              {item.time && !isNaN(new Date(item.time).getTime())
                                ? new Date(item.time).toLocaleTimeString("en-IN", {
                                  hour: "2-digit",
                                  minute: "2-digit",
                                  second: "2-digit",
                                })
                                : "--"}
                            </strong>

                            <span
                              style={{ cursor: item.status === "Delayed" ? "pointer" : "default" }}
                              onClick={() => {
                                if (item.status === "Delayed") {
                                  setOpenDelayIndex(openDelayIndex === index ? null : index);
                                }
                              }}
                            >
                              {item.event}
                            </span>

                            <span
                              className={`status-part ${item.status === "Delayed" ? "text-danger fw-bold" : ""
                                }`}
                            >
                              {item.status}
                              {item.status === "Delayed"
                                ? openDelayIndex === index
                                  ? " ▲"
                                  : " ▼"
                                : ""}
                            </span>

                            {item.status === "Delayed" && openDelayIndex === index && (
                              <div className="w-100 ps-2 mt-1 text-muted small">
                                Reason: {item.reason || "--"}
                              </div>
                            )}
                          </li>
                        ))}

                      </ul>
                      <div className="row">
                        <div className="col-md-12">

                          <div className="accordion mt-3" id="accordionExample">

                            {[
                              { key: "clinic", name: "Clinic" },
                              { key: "designer", name: "Designer" },
                              { key: "milling", name: "Milling" },
                              { key: "delivery", name: "Delivery Partner" }
                            ].map((section) => (

                              <div key={section.key} className="accordion-item border rounded p-2 mt-3">

                                <h2 className="accordion-header">
                                  <button
                                    className={`accordion-button ${section.key !== "clinic" ? "collapsed" : ""}`}
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#${section.key}`}
                                  >
                                    {section.name}
                                  </button>
                                </h2>

                                <div
                                  id={section.key}
                                  className={`accordion-collapse collapse ${section.key === "clinic" ? "show" : ""}`}
                                  data-bs-parent="#accordionExample"
                                >
                                  <div className="accordion-body">

                                    {/* NAME */}
                                    <div className="doctor-name-bottom">
                                      {
                                        section.key === "clinic" ? orderDetails?.clinic || "--" :
                                          section.key === "designer" ? orderDetails?.design || "--" :
                                            section.key === "milling" ? orderDetails?.milling || "--" :
                                              orderDetails?.deliveryPartner || "--"
                                      }
                                    </div>

                                    {/* MOBILE */}
                                    <div className="doctor-name-bottom">
                                      {
                                        section.key === "clinic" ? orderDetails?.clinicMobileNo || "--" :
                                          section.key === "designer" ? orderDetails?.designMobileNo || "--" :
                                            section.key === "milling" ? orderDetails?.millingMobileNo || "--" :
                                              orderDetails?.deliveryPartnerMobileNo || "--"
                                      }
                                    </div>

                                    {/* ADDRESS */}
                                    {section.key !== "designer" && (
                                      <div className="doctor-name-bottom">
                                        {
                                          section.key === "clinic" ? orderDetails?.clinicAddress || "--" :
                                            section.key === "milling" ? orderDetails?.millingAddress || "--" :
                                              orderDetails?.deliveryPartnerAddress || "--"
                                        }
                                      </div>
                                    )}

                                  </div>
                                </div>

                              </div>
                            ))}

                          </div>
                        </div>
                      </div>
                    </div>

                  </div>
                )}


                {activeTab === "details" && <div>

                  <div className="row p-0">

                    {/* 🔹 LEFT SECTION (TABLE) */}
                    <div className="col-lg-9 col-md-12 col-12">
                      <table className="table table-sm table-borderless table-content-insidethetable">

                        <thead>
                          <tr>
                            <th>Tooth</th>
                            <th>Material</th>
                            <th>Shade</th>
                            <th>Design</th>
                          </tr>
                        </thead>

                        <tbody>
                          {orderReview.map((review, index) => (
                            <tr key={index}>
                              <td>{review.tooth || "--"}</td>
                              <td>{review.material || "--"}</td>
                              <td>{review.shade || "--"}</td>
                              <td className="scrollable-td text-truncate" style={{ minWidth: "200px" }}>
                                <div className="imageloaded-stlfile-padding-right-file">
                                  {renderDesignFiles(review)}
                                </div>
                              </td>
                            </tr>
                          ))}
                        </tbody>

                      </table>
                    </div>

                    {/* 🔹 RIGHT SECTION (SCANS) */}
                    <div className="col-lg-3 col-md-12 col-12 border-start px-2">

                      <strong className="scans-fontweight500 mb-2 mt-3 d-block">
                        Scans (By Dentist)
                      </strong>

                      {scans.length === 0 ? (
                        <p className="text-muted">No scans available</p>
                      ) : (
                        scans.map((scan, index) => (
                          <div
                            key={index}
                            className="scan-item d-flex justify-content-between align-items-center mt-2 px-2 py-1 border rounded"
                          >
                            <span
                              className="text-truncate"
                              style={{ maxWidth: "120px" }}
                              title={scan.name}
                            >
                              {scan.name}
                            </span>

                            <div className="d-flex gap-2">
                              <i
                                className="bi bi-eye"
                                title="View STL"
                                style={{ cursor: "pointer" }}
                                onClick={() => {
                                  onViewStl(scan);
                                }}
                              ></i>

                              <i
                                className="bi bi-download text-primary"
                                title="Download STL"
                                style={{ cursor: "pointer" }}
                               onClick={async (e) => {
  e.preventDefault();
  e.stopPropagation();
  await downloadFile(scan.path, scan.name);
}}
                              ></i>
                            </div>
                          </div>
                        ))
                      )}
                    </div>
                  </div>
                </div>}


              </div>
            </div>
          </div>

        </div>


      )}

    </div>

  )

}

export default CancelOrderAdmin;